import React from 'react';
export function Footer() {
  return <footer className="py-10 px-6 md:px-[72px] border-t border-subdued flex flex-col md:flex-row justify-between items-center gap-4 text-center md:text-left" data-id="element-171">
      <div className="font-serif text-lg font-semibold text-cream" data-id="element-172">
        Get<em className="not-italic text-gold-bright" data-id="element-173">More</em>Scores
      </div>
      <p className="text-xs text-[#2e2e2e] tracking-wide" data-id="element-174">
        © 2025 GetMoreScores.com · Todos los derechos reservados
      </p>
      <p className="text-xs text-[#2e2e2e] tracking-wide" data-id="element-175">
        Los resultados pueden variar según el negocio, mercado y ejecución.
      </p>
    </footer>;
}